import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export const useSeeMore = (list, step = 5) => {
  const [count, setCount] = useState(step);
  const items = Array.isArray(list) ? list : [];
  return { shown: items.slice(0, count), total: items.length, count, more: () => setCount((c) => c + step), less: () => setCount(step) };
};

export const SeeMore = ({ total, count, more, less, testId }) => {
  if (total <= 5) return null;
  return (
    <div className="flex items-center justify-center gap-3 border-t border-black/10 px-5 py-3 text-sm">
      {count < total && (
        <button onClick={more} data-testid={`${testId}-see-more`} className="flex items-center gap-1.5 font-semibold underline-offset-4 hover:text-[#E62314] hover:underline">
          <ChevronDown className="h-4 w-4" />See more <span className="font-normal text-[#57534E]">({total - count} older)</span>
        </button>
      )}
      {count > 5 && (
        <button onClick={less} data-testid={`${testId}-show-less`} className="flex items-center gap-1.5 font-semibold underline-offset-4 hover:text-[#E62314] hover:underline">
          <ChevronUp className="h-4 w-4" />Show less
        </button>
      )}
    </div>
  );
};
